import Layout from "@/components/shared/Layout";
import axios from "axios";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useState } from "react";
import { useTranslation } from "next-i18next";
import Head from "next/head";
import { META_IMAGE, SITE_URL } from "@/utils/meta";

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale || "az")),
    },
  };
}
const Faq = () => {
  const { t, i18n } = useTranslation();
  const pageUrl = `${SITE_URL}${i18n.language === "az" ? "" : `/${i18n.language}`}/faq`;
  const tabs = [t("all"), t("trust-safety"), t("services")];
  const contents = [
    {
      title:t('faq-1-head'),
      description:t('faq-1-def')
    },
    {
      title:t('faq-2-head'),
      description:t('faq-2-def')
    },
    {
      title:t('faq-3-head'),
      description:t('faq-3-def')
    },
    {
      title:t('faq-4-head'),
      description:t('faq-4-def')
    },
    {
      title:t('faq-5-head'),
      description:t('faq-5-def')
    },
    {
      title:t('faq-6-head'),
      description:t('faq-6-def')
    },
    {
      title:t('faq-7-head'),
      description:t('faq-7-def')
    },
  ]


  const scrollToSection = (sectionId, position) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: position,
      });
    }
  };
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{t("title-faq")}</title>
        <meta name="keywords" content="faq peerstack " />
        <meta name="description" content={t("description-faq")} />
        <meta name="image" content={META_IMAGE} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:site_name" content="peerstack.tech" />
        <meta property="og:title" content={t("title-faq")} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:description" content={t("description-faq")} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={META_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("title-faq")} />
        <meta name="twitter:url" content={pageUrl} />
        <meta name="twitter:description" content={t("description-faq")} />
        <meta name="twitter:image" content={META_IMAGE} />
      </Head>
      <Layout scrollToSection={scrollToSection}>
        <div className="flex flex-col items-center gap-[20px] px-mobile py-[30px] sm:gap-[40px] sm:px-desktop">
          <p className="text-[20px] font-[600] tracking-[4.5px] text-main-pink sm:text-[42px]">
            {t("what-we-can")}
          </p>
          <div className="flex w-full flex-col gap-[20px] sm:w-[892px] sm:gap-[24px]">
            
            <div className="flex flex-col gap-[20px] sm:gap-[25px]">
              {contents?.map((item) => (
                <div key={item.title} className="flex flex-col gap-[20px]">
                  <p className="text-[16px] font-[600] text-main sm:text-[20px]">
                    {item.title}
                  </p>
                  <p className="text-[14px] font-[500] text-[#BFBFBF] sm:text-[20px]">
                    {item.description}
                  </p>
                  <div className="w-full border-b-[1px] border-[#C2C2C2]" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Faq;
